import moment from 'moment-timezone';

const localTimezone = moment.tz.guess(true);

export default {
  /***
   * kst에서 unix타임 얻어내기
   */
  unixTime(timeString){
    if (!timeString.includes('+')  && !timeString.endsWith('+09:00')) {
      timeString = timeString + '+09:00';
    }

    return new Date(moment(timeString)).valueOf();
  },

  /***
   * kst에서 local timezone로 변환
   */
  kstToLtz(timeString, format = "YYYY-MM-DD HH:mm:ss") {
    if (!timeString.includes('+')  && !timeString.endsWith('+09:00')) {
      timeString = timeString + '+09:00';
    }

    return moment(timeString).tz(localTimezone).format(format);
  },
  /***
   * local timezone에서 kst로 변환
   */
  ltzToKst(timeString, format = "YYYY-MM-DDTHH:mm:ss") {
    return moment.tz(timeString, localTimezone).clone().tz("Asia/Seoul").format(format);
  }
}
